import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper, ReportFilesToolBar } from '../';
import { CustomFilterExport } from '../CustomFilterExport';
import { appConfig } from '../../settings';
import { useCallDataRecordsFilterParams, useProfile, useProfileFeatureFlags, useProfileIsRight } from '../../hooks';
import { cleanCallDataRecordsRelationSelectAndStore, getCallDataRecordsRelationSelect } from '../../middleware';
import { CallDataRecordsTableList } from './Components/';

const Buttons: React.FC = observer(() => {
    const { isCompanyTypeIdMNOHost } = useProfile();
    const filterParams = useCallDataRecordsFilterParams();
    return (
        <Catcher>
            <CustomFilterExport
                filterParams={filterParams}
                exportButtons={
                    <ReportFilesToolBar
                        filterParams={filterParams}
                        type={'POST_CALL_DATA_RECORDS'}
                        isPdf={!isCompanyTypeIdMNOHost}
                        isCsv={true}
                    />
                }
            />
        </Catcher>
    );
});

export const CallDataRecordsList: React.FC = observer(() => {
    const filterParams = useCallDataRecordsFilterParams();
    const { companyId } = useProfile();
    const isLord = useProfileIsRight('LORD');
    const newChargingSystem = useProfileFeatureFlags().newChargingSystem;

    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanCallDataRecordsRelationSelectAndStore}
                defaultParams={{ companyId }}
                filterParams={filterParams}
                getRelationSelect={getCallDataRecordsRelationSelect}
                months={
                    newChargingSystem && !isLord
                        ? appConfig.maximumMonthsForRequestForCDRs
                        : appConfig.maximumMonthsForRequest
                }
                // ToDo: 14.02.2025 - remove after test
                // months={appConfig.maximumMonthsForRequestForCDRs}
                RightButtons={Buttons}
            >
                <CallDataRecordsTableList />
            </ListWrapper>
        </Catcher>
    );
});
